import { render, staticRenderFns } from "./ResearchGEMTableFeatures.vue?vue&type=template&id=7ab0d8bf"
import script from "./ResearchGEMTableFeatures.vue?vue&type=script&lang=js"
export * from "./ResearchGEMTableFeatures.vue?vue&type=script&lang=js"
import style0 from "./ResearchGEMTableFeatures.vue?vue&type=style&index=0&id=7ab0d8bf&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ab0d8bf')) {
      api.createRecord('7ab0d8bf', component.options)
    } else {
      api.reload('7ab0d8bf', component.options)
    }
    module.hot.accept("./ResearchGEMTableFeatures.vue?vue&type=template&id=7ab0d8bf", function () {
      api.rerender('7ab0d8bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchGEMTableFeatures.vue"
export default component.exports